(function() { window.GUID_751328e9_97a0_478c_83f6_9e20345591ea = { getGuid: function() { return "751328e9-97a0-478c-83f6-9e20345591ea"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        class NotificationNavigationDomContext {
            static getCurrent() {
                const $element = $(NotificationNavigationDomContext.selector).last();
                if (!$element.length) {
                    return null;
                }
                const notificationId = Number($element.data(NotificationNavigationDomContext.notificationIdDataKey));
                if (!Number.isInteger(notificationId) || notificationId <= 0) {
                    return null;
                }
                return {
                    $element,
                    notificationId,
                };
            }
            static isProcessed($element) {
                return $element.data(NotificationNavigationDomContext.processedDataKey) === true;
            }
            static markAsProcessed($element) {
                $element.data(NotificationNavigationDomContext.processedDataKey, true);
            }
        }
        NotificationNavigationDomContext.selector = ".notification-navigation-context";
        NotificationNavigationDomContext.notificationIdDataKey = "notificationNavigationId";
        NotificationNavigationDomContext.processedDataKey = "notification-mark-as-read-processed";
        class MasterPage {
            get Action() {
                return this.action;
            }
            get Controller() {
                return this.controller;
            }
            get PageTransition() {
                return this.pageTransition;
            }
            static get TopHeight() {
                let height = 0;
                const $topbar = CS.DOM.$lastTopbar();
                const $subTop = CS.DOM.$lastSubTopbar();
                if ($topbar.length) {
                    height += $topbar.outerHeight();
                }
                if ($subTop.length) {
                    height += $subTop.outerHeight();
                }
                if ($("#csr-details-wall-tab-menu").length) {
                    height += $("#csr-details-wall-tab-menu").outerHeight();
                }
                return height;
            }
            static get BottomHeight() {
                let height = 0;
                const $bottom = CS.DOM.$sectionBottom;
                if ($bottom.length) {
                    height += $bottom.outerHeight();
                }
                return height;
            }
            static get SupportsIntersectionObserver() {
                return "IntersectionObserver" in window;
            }
            constructor(slideTransitions = true) {
                this.termsOfServicesShowned = false;
                this.cookieConsentManagerShowned = false;
                this.accountRecoveryShowned = false;
                let me = this;
                if ("scrollRestoration" in history) {
                    history.scrollRestoration = "manual";
                }
                me.slideTransitions = slideTransitions;
                me.setCookies();
                MasterPage.Instance = me;
                CS.DOM.FindMainDOMElements();
                CS.Connection.Create();
                me.masterPageSignalR = new Views.MasterPageSignalR(me);
                CS.Analytics.PageView(window.location.href);
                this.bindBottomBarEvents();
                this.bindGlobalEvents();
                this.markNotificationAsReadIfNeeded();
                //Make sure IsNative is detected correctly
                if (!CS.CommonData.Current.IsNativeApp &&
                    CS.CommonData.Current.UserId != null) {
                    let data = {
                        Success: true,
                        UserDeviceId: CS.CommonData.Current.UserDeviceId,
                        UserId: CS.CommonData.Current.UserId,
                        UserHash: CS.CommonData.Current.UserHash,
                    };
                    CS.NativeApp.NA_SetUserDeviceCompletedV2(JSON.stringify(data));
                }
                const googleLocateUrl = CS.Url.CSUrl("googlelocate");
                if (googleLocateUrl &&
                    CS.CommonData.Current.Latitude == null &&
                    CS.CommonData.Current.UserId) {
                    $.ajax(googleLocateUrl, {
                        type: "POST",
                        success: function (response) {
                            if (response) {
                                const data = {
                                    latitude: response.location.lat,
                                    longitude: response.location.lng,
                                    coordAccuracy: response.accuracy,
                                };
                                CS.CommonData.Current.Latitude = data.latitude;
                                CS.CommonData.Current.Longitude = data.longitude;
                                CS.CommonData.Current.CoordAccuracy = data.coordAccuracy;
                                CS.Ajax.Post(CS.Url.CSUrl("setusercoord"), data, (r) => { });
                            }
                        },
                    });
                }
            }
            setCookies() {
                const pricingUpdateCookie = CS.Cookie.GetCookie(CS.Cookie.Names.Features.PricingUpdate);
                const now = new Date();
                const pricingCookieLimitDate = new Date(2023, 3, 1); // April 1st 2023
                const limitDateIsPassed = now > pricingCookieLimitDate;
                if (limitDateIsPassed) {
                    if (pricingUpdateCookie != null) {
                        CS.Cookie.RemoveCookie(CS.Cookie.Names.Features.PricingUpdate);
                    }
                }
                else {
                    if (pricingUpdateCookie == null) {
                        const now = new Date();
                        let expiresDate = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days
                        if (expiresDate > pricingCookieLimitDate) {
                            expiresDate = pricingCookieLimitDate;
                        }
                        const expiresDays = Math.round((expiresDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
                        const data = {
                            setDate: now.toISOString(),
                            limitDate: pricingCookieLimitDate.toISOString(),
                            expiresDate: expiresDate.toISOString(),
                            seenCount: 0,
                        };
                        CS.Cookie.SetCookie(CS.Cookie.Names.Features.PricingUpdate, JSON.stringify(data), expiresDays);
                    }
                }
            }
            bindGlobalEvents() {
                // Select items that have a data "trigger-player-feature-popup-on-click" equal to "true"
                CS.DOM.$body.offon("click.playerFeaturePopupOnClick", "[data-trigger-player-feature-popup-on-click='true']", (e) => {
                    const $trigger = $(e.currentTarget);
                    const popupUrl = $trigger.data("player-feature-popup-url");
                    if (!CS.Helper.isNullOrWhiteSpace(popupUrl)) {
                        CS.Controls.Popup.ShowAjaxModal(popupUrl, {}, ({ popup }) => { }, ({ popup }) => {
                            //const $overlay = $(".popup .overlay");
                            //$overlay.remove();
                        }, true);
                    }
                });
                CS.DOM.$body.offon("click.triggerClickOnId", ".trigger-click-on-id", (e) => {
                    const $trigger = $(e.currentTarget);
                    const id = $trigger.data("trigger-id");
                    if (!CS.Helper.isNullOrWhiteSpace(id)) {
                        $(`#${id}`).trigger("click");
                    }
                });
                CS.DOM.$body.offon("click.autoPopupTriggerGlobal", ".cs-popup-auto-trigger:not([data-trigger-player-feature-popup-on-click='true'])", (e) => {
                    const $trigger = $(e.currentTarget);
                    const popupUrl = $trigger.data("popup-url");
                    if (!CS.Helper.isNullOrWhiteSpace(popupUrl)) {
                        CS.Controls.Popup.ShowAjaxModal(popupUrl, {}, ({ popup }) => { }, ({ popup }) => {
                            //const $overlay = $(".popup .overlay");
                            //$overlay.remove();
                        }, true, false);
                    }
                });
                CS.DOM.$body.offon("click.flipcointest1", "#cs-coin-flip-trigger", (e) => {
                    CS.Analytics.Event("CoinFlip", "FlipCoin", "FlipCoin");
                    let coin = document.querySelector("#cs-coin-flip-trigger");
                    let i = Math.floor(Math.random() * 2);
                    coin.style.animation = "none";
                    if (i) {
                        CS.Lag("cs-coin-flip-trigger", 100, function () {
                            coin.style.animation = "spin-heads 3s forwards";
                        });
                    }
                    else {
                        CS.Lag("cs-coin-flip-trigger", 100, function () {
                            coin.style.animation = "spin-heads 3s forwards";
                            coin.style.animation = "spin-tails 3s forwards";
                        });
                    }
                });
                CS.DOM.$body.offon("click.GlobalGoogleAnalyticsTriggers", ".cs-ga-trigger", (e) => {
                    const $trigger = $(e.currentTarget);
                    CS.Helper.log("MasterPage", $trigger);
                    if ($trigger.length) {
                        const { category, action, label, value, isValid } = CS.Helper.GoogleAnalyticsHelper.getDataFromElement($trigger);
                        if (isValid) {
                            CS.Analytics.Event(category, action, label, value);
                        }
                    }
                });
                CS.DOM.$body.offon("click.GlobalGoogleAnalyticsTriggers2", ".main-menu-content", (e) => {
                    e.stopImmediatePropagation();
                    CS.Helper.log("MasterPage", "click");
                });
                if (window.clarity && CS.CommonData.Current.UserId) {
                    window.clarity("identify", CS.CommonData.Current.UserId.toString());
                    CS.Helper.log("MasterPage", "clarity user set");
                    //const userIdIsOdd = CommonData.Current.UserId % 2 == 1;
                    //if (userIdIsOdd) {
                    //    (<any>window).clarity("set", "homePageVersion", "A");
                    //} else {
                    //    (<any>window).clarity("set", "homePageVersion", "B");
                    //}
                    window.clarity("set", "debug", CS.CommonData.Current && CS.CommonData.Current.IsDebug() ? "true" : "false");
                    const { Navigation, IsPremium, IsPremiumEssential } = CS.CommonData.Current;
                    const { EventType, WallType, EventId } = Navigation;
                    window.clarity("set", "wallType", WallType);
                    window.clarity("set", "eventType", EventType);
                    window.clarity("set", "isPremium", IsPremium);
                    window.clarity("set", "isEssentials", IsPremiumEssential && !IsPremium);
                    window.clarity("set", "isBasic", !IsPremiumEssential && !IsPremium);
                    window.clarity("set", "eventId", EventId);
                    //upgrade all clarity sessions for now
                    window.clarity("upgrade", "initial release");
                }
                //Verification fait dans _global-csurl.cshtml
                this.termsOfServicesModalUrl = CS.Url.CSUrl("ShowTermsOfServicesModal");
                this.cookieConsentManagerModalUrl = CS.Url.CSUrl("ShowCookieConsentManagerModal");
                this.accountRecoveryModalUrl = CS.Url.CSUrl("ShowRecommendedAccontRecoveryModal");
                if (this.termsOfServicesModalUrl) {
                    this.ShowTermsOfServicesModal();
                }
                else if (this.cookieConsentManagerModalUrl) {
                    this.ShowCookieConsentManagerModal();
                }
                else if (this.accountRecoveryModalUrl) {
                    this.ShowAccountRecovery();
                }
            }
            markNotificationAsReadIfNeeded() {
                const notificationNavigation = NotificationNavigationDomContext.getCurrent();
                if (notificationNavigation == null) {
                    return;
                }
                const { $element, notificationId } = notificationNavigation;
                if (NotificationNavigationDomContext.isProcessed($element)) {
                    return;
                }
                NotificationNavigationDomContext.markAsProcessed($element);
                CS.Ajax.Post(CS.Url.CSUrl("markasread"), { id: notificationId, fromMarkAsReadButton: false }, (count) => {
                    this.RefreshUnreadMessagesCount(count);
                });
            }
            bindBottomBarEvents() {
                CS.DOM.$body.offon("click.bottomBarButton", "#section-bottom button", (e) => {
                    const $button = $(e.currentTarget);
                    const extraData = $button.data("html");
                    if (extraData != null) {
                        const { popupUrl } = extraData;
                        if (popupUrl != null) {
                            CS.Helper.log("MasterPage", popupUrl);
                            CS.Controls.Popup.ShowAjaxModal(popupUrl, {}, ({ popup, isPopup }) => {
                                if (isPopup) {
                                    try {
                                        if (popup != null &&
                                            popup.$Control &&
                                            popup.$Control.length) {
                                            const $mainMenuContent = popup.$Control.find(".main-menu-content");
                                            const isMainMenuPopup = $mainMenuContent.length;
                                            if (isMainMenuPopup) {
                                                const $popupContent = popup.$Control.find(".popup-content");
                                                if ($popupContent.length) {
                                                    $popupContent.css({ overflow: "unset" });
                                                    CS.Lag("popup-content-opacity", 350, () => {
                                                        $popupContent.css({ overflow: "" });
                                                    });
                                                }
                                                CS.Ads.RefreshGoogleAds($mainMenuContent);
                                            }
                                        }
                                    }
                                    catch (error) {
                                        console.error(error);
                                    }
                                }
                            }, ({ popup }) => { }, true);
                        }
                    }
                });
                CS.DOM.$body.offon("click.BottomBarGoogleAnalyticsTriggers", "#section-bottom .bottombar-ga-events-trigger", (e) => {
                    const $trigger = $(e.currentTarget);
                    if ($trigger.length) {
                        const { category, action, label, value, isValid } = CS.Helper.GoogleAnalyticsHelper.getDataFromElement($trigger);
                        if (isValid) {
                            CS.Analytics.Event(category, action, label, value);
                        }
                    }
                });
            }
            Refreshing() {
                if (CS.DOM.$sectionMiddle != null && CS.DOM.$sectionMiddle.length > 0) {
                    this.hideSectionMiddle();
                }
            }
            RefreshingCompleted() {
                if (CS.DOM.$sectionMiddle != null && CS.DOM.$sectionMiddle.length > 0) {
                    this.ShowSectionMiddle();
                }
            }
            RefreshBody() {
                let me = this;
                try {
                    CS.Helper.log("MasterPage", "Refreshing body...");
                    CS.DOM.FindDOMSections();
                    CS.DOM.$win.scrollTop(0);
                    //let scrollListener = new Controls.ScrollListener(DOM.$body);
                    //scrollListener.OnScrollDirectionChange = function (direction: string) {
                    //    if (direction == "down") {
                    //        DOM.$body.addClass("scroll-down");
                    //    }
                    //    else {
                    //        DOM.$body.removeClass("scroll-down");
                    //    }
                    //};
                    //me.RefreshNavigationInformations();
                    CS.Controls.Form.HandleFormValidation();
                    if (CS.CommonData.Current.Navigation.Controller == 'settings' && CS.CommonData.Current.Navigation.Action == 'consentcommunicationpreferences') {
                        this.initializeCookieConsentManagers(CS.DOM.$body);
                    }
                    CS.DOM.$win.on("resize.masterpage", function () {
                        if (!CS.DOM.$sectionMiddle.hasClass("refreshing")) {
                            CS.DOM.Refreshed();
                        }
                    });
                    //DOM.$body.on('keydown', function (e, d) {
                    //    html2canvas(document.body).then(function (canvas) {
                    //        document.body.appendChild(canvas);
                    //    });
                    //});
                    //DOM.sectionMaster.show();//voir ligne 5 masterpage.less
                    //this.showSectionMiddle();
                    CS.Shared.WallSectionLazyLoader.init();
                    this.markNotificationAsReadIfNeeded();
                    CS.Events.$On("errorclosed.masterpage", function () {
                        me.RefreshingCompleted();
                    });
                }
                finally {
                    CS.DOM.Refreshed();
                }
                //Events.$On("section-middle-refreshed.masterpage", () => {
                //    MasterPage.RefreshLastSubTopbarStickyTop();
                //});
            }
            static ShowNotificationMessage(content) {
                CS.Lag("notif", 200, function () {
                    let $masterNotifContent = $(".master-notifications-content");
                    $masterNotifContent.html(content);
                    $masterNotifContent.slideDown(150, () => {
                        setTimeout(() => {
                            $masterNotifContent.slideUp(150, () => {
                                $masterNotifContent.empty();
                            });
                        }, 2000);
                    });
                });
            }
            setControllerPagePosition(controller) {
                switch (controller) {
                    case MainWallName.DivisionWall:
                        return 2;
                    case MainWallName.EventWall:
                        return 1;
                    case MainWallName.Messages:
                        return 5;
                    case MainWallName.PinsWall:
                        return 4;
                    case MainWallName.StatsWall:
                        return 3;
                    default:
                        return -1;
                }
            }
            ShowSectionMiddle() {
                CS.DOM.$sectionMiddle.removeClass("refreshing");
                const $firstsection = CS.DOM.$sectionMiddle;
                const $sections = CS.DOM.$sectionMiddle == CS.DOM.$lastSectionMiddle()
                    ? $firstsection
                    : $firstsection.add(CS.DOM.$lastSectionMiddle());
                $sections.each((index, element) => {
                    const $section = $(element);
                    if ($section.length > 0 && !$section.hasClass("has-transitioned")) {
                        let patchTemp = true; //sinon, le gridfixedheader est pété
                        if (this.pageTransition == PageTransition.Opacity || patchTemp) {
                            $section.animate({
                                opacity: 1,
                            }, 50, () => {
                                //Events.Trigger("section-middle-refreshed.masterpage");
                                //console.log(DOM.$lastTopbar());
                                //console.log(DOM.$lastTopbar().outerHeight());
                            });
                        }
                        else {
                            const translateValue = this.pageTransition == PageTransition.FromLeft ? "-100%" : "100%";
                            $section.css({
                                transform: `translateX(${translateValue})`,
                            });
                            CS.DOM.$body.addClass("overflow-x--hidden");
                            $section.animate({
                                opacity: 0.01, // Il faut que l'opacité soit > 0 sinon ça glitch la transition
                            }, 10, () => {
                                const transitionTime = 500;
                                $section.css({
                                    transition: `transform ease ${transitionTime / 1000}s, opacity ease ${transitionTime / 1000}s`,
                                    transform: "translateX(0)",
                                    opacity: 1,
                                });
                                CS.Lag("showSectionMiddle", transitionTime, () => {
                                    CS.DOM.$body.removeClass("overflow-x--hidden");
                                    $section.css({
                                        transition: "none",
                                        transform: "none",
                                    });
                                    //Events.Trigger("section-middle-refreshed.masterpage");
                                });
                            });
                        }
                        $section.addClass("has-transitioned");
                    }
                });
                if (!CS.DOM.$sectionMiddle.hasClass("native-app-popup-checked")) {
                    CS.Helper.ShowDownloadNativeAppPopupIfNeeded(() => {
                        CS.DOM.$sectionMiddle.addClass("native-app-popup-checked");
                    });
                }
            }
            hideSectionMiddle() {
                CS.DOM.$sectionMiddle.addClass("refreshing");
                //switch (this.pageTransition) {
                //    case PageTransition.FromLeft:
                //        DOM.$sectionMiddle.css({ transition: "refreshing ease 0.15s", transform: "translateX(-100vw)" });
                //        break;
                //    case PageTransition.FromRight:
                //        DOM.$sectionMiddle.css({ transition: "refreshing ease 0.15s", transform: "translateX(100vw)" });
                //        break;
                //    case PageTransition.Opacity:
                CS.DOM.$sectionMiddle.css({ transition: "opacity ease 0.05s", opacity: 0 });
                if (CS.DOM.$lastSectionMiddle() != CS.DOM.$sectionMiddle)
                    CS.DOM.$lastSectionMiddle().css({
                        transition: "opacity ease 0.05s",
                        opacity: 0,
                    });
                //        break;
                //    default:
                //}
            }
            RefreshNavigationInformations() {
                if (CS.CommonData.Current) {
                    const nav = CS.CommonData.Current.Navigation;
                    if (!nav)
                        return; //How can this happen?  Errors on azure
                    this.replaceControllerActionCssClasses(nav);
                    this.action = nav.Action;
                    this.controller = nav.Controller;
                    let lastController = CS.DOM.$body.data("last-controller");
                    /*
                                                                                Pour fixer la classe "controller" qui est dupliquée lors de la première navigation.
                                                                                
                                                                                Pas sûre de la raison exacte, mais de recaller "replaceControllerActionCssClasses" permet
                                                                                de retirer la classe dupliquée..
                                                                                
                                                                                La data "lastController" ne devrait plus être null après une première navigation,
                                                                                donc "replaceControllerActionCssClasses" ne sera plus callé 2 fois par la suite.
                                                                             */
                    if (lastController == null)
                        this.replaceControllerActionCssClasses(nav);
                    this.controllerIsMainWall = Object
                        .values(MainWallName)
                        .includes(nav.Controller);
                    this.lastControllerIsMainWall = Object
                        .values(MainWallName)
                        .includes(lastController);
                    this.controllerPagePosition = this.controllerIsMainWall
                        ? this.setControllerPagePosition(this.controller)
                        : -1;
                    this.lastControllerPagePosition = this.lastControllerIsMainWall
                        ? this.setControllerPagePosition(lastController)
                        : -1;
                    if (!this.slideTransitions) {
                        this.pageTransition = PageTransition.Opacity;
                    }
                    else {
                        if (this.controllerIsMainWall &&
                            this.lastControllerIsMainWall &&
                            this.controller != lastController) {
                            this.pageTransition =
                                this.lastControllerPagePosition < this.controllerPagePosition
                                    ? PageTransition.FromRight
                                    : PageTransition.FromLeft;
                        }
                        else {
                            this.pageTransition = PageTransition.Opacity;
                        }
                    }
                    document.title = CS.CommonData.Current.Navigation.PageTitle;
                    CS.DOM.$head
                        .find('meta[property="al:ios:url"]')
                        .attr("content", CS.CommonData.Current.Navigation.NativeAppCustomUrl);
                    CS.DOM.$head
                        .find('meta[property="al:android:url"]')
                        .attr("content", CS.CommonData.Current.Navigation.NativeAppCustomUrl);
                }
            }
            replaceControllerActionCssClasses(nav) {
                let classes = CS.DOM.$body[0].classList;
                // Lors d'une première navigation, classes ne contient pas la classe "controller-[FIRST_PAGE]". Elle n'est donc pas retirée
                for (let i = 0; i < classes.length; i++) {
                    let cssClass = classes[i];
                    if (cssClass.indexOf("controller-") > -1 ||
                        cssClass.indexOf("action-") > -1) {
                        CS.DOM.$body.removeClass(cssClass);
                    }
                }
                CS.DOM.$body.addClass("controller-" + nav.Controller);
                CS.DOM.$body.addClass("action-" + nav.Action);
                if (CS.CommonData.Current.Language) {
                    CS.DOM.$body.addClass("lang-" + CS.CommonData.Current.Language.toLowerCase());
                }
            }
            static RemoveLastBodyClasses() {
                const nav = CS.CommonData.Current.Navigation;
                if (CS.DOM.$body.data("last-controller") != null) {
                    let lastController = CS.DOM.$body.data("last-controller");
                    let lastAction = CS.DOM.$body.data("last-action");
                    if (lastController != nav.Controller) {
                        CS.DOM.$body.removeClass("controller-" + lastController);
                    }
                    if (lastAction != nav.Action) {
                        CS.DOM.$body.removeClass("action-" + lastAction);
                    }
                }
                CS.DOM.$body.data("last-controller", nav.Controller);
                CS.DOM.$body.data("last-action", nav.Action);
            }
            OnNewMessagesReceived() {
                this.RefreshUnreadMessagesCount();
                CS.DOM.$body.trigger("newmessagereceived");
            }
            RefreshUnreadMessagesCount(count = null, callback = null) {
                let me = this;
                CS.Lag("unread-message-count-masterpage", 500, function () {
                    if (count != null) {
                        if (CS.DOM.$topBar.length > 0) {
                            let $unreadMessagesCount = CS.DOM.$topBar.find("#button-notifications-top .badge");
                            if ($unreadMessagesCount.length > 0) {
                                let $spanMessageCount = $unreadMessagesCount.find(".count");
                                let currentCount = parseInt($spanMessageCount[0].innerHTML.trim());
                                if (Number.isNaN(currentCount)) {
                                    currentCount = 0;
                                }
                                if (currentCount != count) {
                                    if (count == 0) {
                                        $spanMessageCount[0].innerHTML = "";
                                        $unreadMessagesCount.hide();
                                    }
                                    else if (count > 99) {
                                        $spanMessageCount[0].innerHTML = "99+";
                                        $unreadMessagesCount.show();
                                    }
                                    else {
                                        $spanMessageCount[0].innerHTML = count.toString();
                                        $unreadMessagesCount.show();
                                    }
                                }
                            }
                        }
                        if (callback) {
                            callback(count);
                        }
                    }
                    else {
                        CS.Ajax.Get(CS.Url.CSUrl("getunreadmessagescount"), null, function (response) {
                            me.RefreshUnreadMessagesCount(response.UnreadMessagesCount, callback);
                        });
                    }
                });
            }
            //public static RefreshLastSubTopbarStickyTop() {
            //    const $topbar = DOM.$lastTopbar();
            //    const $subTopbar = DOM.$lastSubTopbar();
            //    if ($subTopbar.length > 0 && $subTopbar.hasClass("sticky")) {
            //        let top = 0;
            //        console.log($subTopbar);
            //        if ($topbar.length > 0) {
            //            console.log($topbar);
            //            top += $topbar.outerHeight();
            //        }
            //        console.log(top);
            //        $subTopbar.css({ top });
            //    }
            //}
            setAnimationOnSearchbar() {
                const $innerSubtop = $(".section-inner-subtop").last();
                if ($innerSubtop.length > 0) {
                    const topbarHeight = $(".section-top").last().outerHeight();
                    const $searchBar = $innerSubtop.find(".app__search-bar");
                    if ($searchBar.length > 0 && !this.isIE()) {
                        const searchbarHeight = $searchBar.outerHeight();
                        $innerSubtop.css({
                            top: `${topbarHeight - searchbarHeight - 1}px`,
                        });
                        const rootMargin = `-${topbarHeight}px 0px 0px 0px`;
                        const threshold = [];
                        for (let i = 0; i < 100; i++) {
                            threshold.push(i / 100);
                        }
                        const config = {
                            rootMargin,
                            threshold,
                        };
                        const $magnifier = $("#button-magnifier");
                        const $magnifierIcon = $magnifier.find("div").first();
                        const observer = new IntersectionObserver((entries, observer) => {
                            entries.forEach((entry) => {
                                let number = Math.round(entry.intersectionRatio * 100) / 100;
                                $searchBar.css({
                                    opacity: number,
                                });
                                // Finalement on va toujours afficher la loupe pareil pour pas que les clients la cherche..
                                //$magnifier.css({
                                //    opacity: 1 - number,
                                //});
                                if (number == 0) {
                                    $magnifierIcon.css({
                                        position: "absolute",
                                    });
                                    $magnifierIcon.animate({
                                        "font-size": "1.3em",
                                    }, 100, () => {
                                        $magnifierIcon.animate({
                                            position: "relative",
                                            "font-size": "1em",
                                        }, 100, () => { });
                                    });
                                }
                            });
                        }, config);
                        observer.observe($searchBar[0]);
                    }
                }
            }
            isIE() {
                let isIE = false;
                const ua = window.navigator.userAgent;
                const msie = ua.indexOf("MSIE ");
                if (msie > 0) {
                    // IE 10 or older => return version number
                    isIE = true;
                }
                const trident = ua.indexOf("Trident/");
                if (trident > 0) {
                    isIE = true;
                }
                return isIE;
            }
            SetPersonaTheme() {
                const $masterOverlay = $(".master-overlay");
                let $hiddenInput;
                let val = "";
                if ($masterOverlay.length > 0)
                    $hiddenInput = $masterOverlay
                        .find(".navigation-persona-is-selected")
                        .last();
                else
                    $hiddenInput = $(".navigation-persona-is-selected").last();
                if ($hiddenInput != null && $hiddenInput.length > 0)
                    val = $hiddenInput.val();
                if (val == "True" || val == "true")
                    CS.DOM.$body.addClass("persona-selected");
                else
                    CS.DOM.$body.removeClass("persona-selected");
            }
            static ScrollToSectionFromSelector(selector) {
                const $section = $(selector);
                CS.Helper.log("MasterPage", $section);
                if ($section.length) {
                    this.ScrollToSection($section);
                }
            }
            static ScrollToSection($section, classToAdd = "highlighted-blink", offset = 0, toggleClassIfSectionHasClass = true, scrollToTop = false) {
                let me = this;
                CS.Lag("scroll-to-lag", 250, function () {
                    const y = MasterPage.GetAccordionSectionTop($section);
                    let accordion = null;
                    try {
                        accordion = CS.Controls.GetInstance(CS.Controls.Accordion, $section);
                    }
                    catch (error) { }
                    if (accordion == null) {
                        window.scrollTo({ top: y + offset, behavior: "smooth" });
                        if (classToAdd) {
                            if (!$section.hasClass(classToAdd))
                                $section.addClass(classToAdd);
                            else if (toggleClassIfSectionHasClass) {
                                $section.removeClass(classToAdd);
                                CS.Lag(classToAdd, 100, () => {
                                    $section.addClass(classToAdd);
                                });
                            }
                        }
                    }
                    else {
                        if (!accordion.IsExpanded) {
                            accordion.ExpandCollapse(true, () => {
                                window.scrollTo({ top: y + offset, behavior: "smooth" });
                                if (classToAdd) {
                                    if (!$section.hasClass(classToAdd))
                                        $section.addClass(classToAdd);
                                    else if (toggleClassIfSectionHasClass) {
                                        $section.removeClass(classToAdd);
                                        CS.Lag(classToAdd, 100, () => {
                                            $section.addClass(classToAdd);
                                        });
                                    }
                                }
                            });
                        }
                        else {
                            window.scrollTo({ top: y + offset, behavior: "smooth" });
                            if (classToAdd) {
                                if (!$section.hasClass(classToAdd))
                                    $section.addClass(classToAdd);
                                else if (toggleClassIfSectionHasClass) {
                                    $section.removeClass(classToAdd);
                                    CS.Lag(classToAdd, 100, () => {
                                        $section.addClass(classToAdd);
                                    });
                                }
                            }
                        }
                        CS.Helper.log("MasterPage", `y: ${y}`);
                        CS.Helper.log("MasterPage", `offset: ${offset}`);
                    }
                });
            }
            static GetAccordionSectionTop($section) {
                let y = 0;
                if ($section && $section.length > 0) {
                    y =
                        $section[0].getBoundingClientRect().top +
                            (window.pageYOffset || document.documentElement.scrollTop);
                }
                const $topbar = $(".section-top").last();
                const $innerSubtop = $(".section-inner-subtop").last();
                if ($topbar.length > 0) {
                    y -= $topbar.outerHeight();
                }
                if ($innerSubtop.length > 0) {
                    y -= $innerSubtop.outerHeight();
                }
                //let marginTop = parseFloat($section.css('margin-top').replace('px', ''));
                //y += marginTop;
                return y;
            }
            ShowTermsOfServicesModal(forced = false) {
                setTimeout(() => {
                    const showModalUrl = this.termsOfServicesModalUrl;
                    const postUrl = CS.Url.CSUrl("TermsOfServicesAccepted");
                    const renderCondition = showModalUrl != null &&
                        postUrl != null &&
                        (!this.termsOfServicesShowned || forced);
                    var data = {};
                    if (renderCondition) {
                        CS.Controls.Popup.ShowAjaxModal(showModalUrl, { forced }, ({ popup }) => {
                            var _a;
                            // Popup loaded
                            const isTermsOfServicesAndSharingAcceptedCheckbox = document.getElementById("checkbox-istermsofservicesandsharingaccepted-child");
                            const isAssociationMarketingAcceptedCheckbox = document.getElementById("checkbox-isassociationmarketingaccepted-child");
                            if (!isTermsOfServicesAndSharingAcceptedCheckbox)
                                return;
                            CS.Controls.Button.Events.Clicked({
                                selector: "#button-accept",
                                callback: (button, e) => {
                                    var _a;
                                    e.jqueryEventObject.preventDefault();
                                    const canSubmit = isTermsOfServicesAndSharingAcceptedCheckbox.checked;
                                    if (!canSubmit) {
                                        const popupContent = $(".popup-content");
                                        if (popupContent.length) {
                                            popupContent[0].scrollTo({
                                                top: popupContent[0].scrollHeight,
                                                behavior: 'smooth'
                                            });
                                        }
                                        const checkbox = $("#checkbox-istermsofservicesandsharingaccepted");
                                        checkbox.removeClass("highlighted-blink");
                                        setTimeout(() => {
                                            checkbox.addClass("highlighted-blink");
                                        }, 10);
                                        const errorMessage = (_a = $("#TermsOfServicesErrorMessage")) === null || _a === void 0 ? void 0 : _a.val();
                                        if (errorMessage) {
                                            CS.Controls.Snackbar.Show({
                                                Id: "accept-tos-error-snackbar",
                                                Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                                Type: CS.Enumeration.SnackbarType.Danger,
                                                AutoHideDuration: 3000,
                                                Message: errorMessage,
                                            });
                                        }
                                        return;
                                    }
                                    data = {
                                        isAssociationMarketingAccepted: isAssociationMarketingAcceptedCheckbox.checked
                                    };
                                    popup.Proceed = true;
                                    popup.Close(false);
                                }
                            });
                            CS.Controls.Button.Events.Clicked({
                                selector: "#button-postpone",
                                callback: (button, e) => {
                                    e.jqueryEventObject.preventDefault();
                                    data = { isPostponed: true };
                                    popup.Proceed = true;
                                    popup.Close(false);
                                },
                            });
                            const expiryElement = document.getElementById("grace-expiry-time");
                            const language = (_a = $("#TermsOfServicesLanguage")) === null || _a === void 0 ? void 0 : _a.val();
                            if (!expiryElement) {
                                return;
                            }
                            // Device time now
                            const now = new Date();
                            // Device time + 4 hours
                            const expiry = new Date(now.getTime() + (4 * 60 * 60 * 1000));
                            const formatted = expiry.toLocaleString(language, {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit"
                            });
                            expiryElement.textContent = " " + formatted;
                        }, ({ popup }) => {
                            if (popup.Proceed) {
                                this.termsOfServicesShowned = true;
                                CS.Ajax.Post(postUrl, data, (response) => {
                                });
                            }
                        }, false);
                    }
                }, 1000);
            }
            ShowCookieConsentManagerModal() {
                setTimeout(() => {
                    const showModalUrl = this.cookieConsentManagerModalUrl;
                    const postUrl = CS.Url.CSUrl("CookieConsentCompleted");
                    let data = {};
                    const renderCondition = showModalUrl != null &&
                        postUrl != null &&
                        !this.cookieConsentManagerShowned;
                    if (renderCondition) {
                        data = { IsCookieConsentCompleted: false, AcceptAll: false, RejectAll: false };
                        CS.Controls.Popup.ShowAjaxModal(showModalUrl, null, ({ popup, isPopup }) => {
                            if (!isPopup) {
                                const response = popup;
                                if (response.is("[data-cookie-consent-completed='true']")) {
                                    this.cookieConsentManagerShowned = true;
                                }
                                return;
                            }
                            // Popup loaded
                            const $manager = popup.$Control.find(".js-cookie-consent-manager").first();
                            this.initializeCookieConsentManagers($manager);
                            // Handle CUSTOMIZE button
                            CS.Controls.Button.Events.Clicked({
                                selector: "#button-customize-choice",
                                callback: (button, e) => {
                                    e.jqueryEventObject.preventDefault();
                                    $manager.find("#button-customize-choice").slideUp();
                                    $manager.find(".cookie-consent-customize-section").slideDown();
                                    $manager.find("#button-confirm-choice").slideDown();
                                    return;
                                },
                            });
                            // Handle ACCEPT ALL button
                            CS.Controls.Button.Events.Clicked({
                                selector: "#button-accept-all",
                                callback: (button, e) => {
                                    e.jqueryEventObject.preventDefault();
                                    data = this.buildCookieConsentData($manager, true, false);
                                    this.applyCookieConsentToCurrentPage(data);
                                    popup.Close(false);
                                },
                            });
                            // Handle REJECT ALL button
                            CS.Controls.Button.Events.Clicked({
                                selector: "#button-reject-all",
                                callback: (button, e) => {
                                    e.jqueryEventObject.preventDefault();
                                    data = this.buildCookieConsentData($manager, false, true);
                                    this.applyCookieConsentToCurrentPage(data);
                                    popup.Close(false);
                                },
                            });
                            // Handle CONFIRM CHOICE button
                            CS.Controls.Button.Events.Clicked({
                                selector: "#button-confirm-choice",
                                callback: (button, e) => {
                                    e.jqueryEventObject.preventDefault();
                                    data = this.buildCookieConsentData($manager);
                                    this.applyCookieConsentToCurrentPage(data);
                                    popup.Close(false);
                                },
                            });
                        }, () => {
                            this.cookieConsentManagerShowned = true;
                            CS.Ajax.Post(postUrl, data, (response) => {
                            });
                        }, false);
                    }
                }, 1000);
            }
            applyCookieConsentToCurrentPage(data) {
                const cookieConsent = CS.CookieConsent;
                if (cookieConsent && typeof cookieConsent.ApplyUpdatedConsent === "function") {
                    cookieConsent.ApplyUpdatedConsent(data);
                }
            }
            initializeCookieConsentManagers($root) {
                const $managers = $root.hasClass("js-cookie-consent-manager")
                    ? $root
                    : $root.find(".js-cookie-consent-manager");
                $managers.each((index, element) => {
                    const $manager = $(element);
                    if ($manager.data("cookieConsentInitialized") === true) {
                        return;
                    }
                    $manager.data("cookieConsentInitialized", true);
                    this.initializeCookieConsentToggleSync($manager);
                    $manager.offon("click.cookieConsentInlineSave", "#button-save-cookie-consent", () => {
                        const data = this.buildCookieConsentData($manager);
                        this.applyCookieConsentToCurrentPage(data);
                    });
                });
            }
            buildCookieConsentData($root, acceptAll = false, rejectAll = false) {
                if (acceptAll) {
                    return {
                        IsCookieConsentCompleted: true,
                        AcceptAll: true,
                        RejectAll: false,
                    };
                }
                if (rejectAll) {
                    return {
                        IsCookieConsentCompleted: true,
                        AcceptAll: false,
                        RejectAll: true,
                    };
                }
                const IsFunctionalAppPreferenceAccepted = this.getCheckboxValue($root, "checkbox-cookie-consent-functional-app-preferences");
                const IsAnalyticsAppAccepted = this.getCheckboxValue($root, "checkbox-cookie-consent-analytics-app");
                const IsMarketingGoogleAccepted = this.getCheckboxValue($root, "checkbox-cookie-consent-marketing-google");
                const IsAnalyticsMetaAccepted = this.getCheckboxValue($root, "checkbox-cookie-consent-analytics-meta");
                const IsFunctionalYoutubeAccepted = this.getCheckboxValue($root, "checkbox-cookie-consent-functional-youtube");
                return {
                    IsCookieConsentCompleted: true,
                    AcceptAll: false,
                    RejectAll: false,
                    IsFunctionalAppPreferenceAccepted,
                    IsAnalyticsAppAccepted,
                    IsMarketingGoogleAccepted,
                    IsAnalyticsMetaAccepted,
                    IsFunctionalYoutubeAccepted,
                };
            }
            getCheckboxElement($root, checkboxId) {
                const $checkbox = $root.find(`#${checkboxId}`).first();
                if ($checkbox.length) {
                    return $checkbox;
                }
                return $(`#${checkboxId}`).first();
            }
            setCheckboxValue($root, checkboxId, value) {
                const $Checkbox = this.getCheckboxElement($root, checkboxId);
                if (!$Checkbox.length) {
                    return;
                }
                const checkbox = CS.Controls.GetInstance(CS.Controls.CheckBox, $Checkbox, true);
                if (checkbox != null) {
                    checkbox.SetValue(value, CS.Controls.ChecboxEventBypass.Both);
                    return;
                }
                const $checkboxInput = $Checkbox.find("input[type=checkbox]").first();
                const isChecked = value === true;
                $checkboxInput.prop("checked", isChecked);
                $Checkbox.toggleClass("checked", isChecked);
                $Checkbox.toggleClass("unchecked", !isChecked);
                $Checkbox.removeClass("indeterminated");
            }
            getCheckboxValue($root, checkboxId) {
                const $Checkbox = this.getCheckboxElement($root, checkboxId);
                let checkboxValue = false;
                if ($Checkbox.length) {
                    const checkbox = CS.Controls.GetInstance(CS.Controls.CheckBox, $Checkbox, true);
                    if (checkbox != null) {
                        checkboxValue = checkbox.GetValue().toLowerCase() == "true";
                    }
                    else {
                        checkboxValue = $Checkbox.hasClass("checked");
                    }
                }
                return checkboxValue;
            }
            initializeCookieConsentToggleSync($root) {
                const configs = [
                    {
                        categoryCheckboxId: "checkbox-cookie-consent-functional",
                        serviceCheckboxIds: [
                            "checkbox-cookie-consent-functional-app-preferences",
                            "checkbox-cookie-consent-functional-youtube",
                        ],
                    },
                    {
                        categoryCheckboxId: "checkbox-cookie-consent-analytics",
                        serviceCheckboxIds: [
                            "checkbox-cookie-consent-analytics-google",
                            "checkbox-cookie-consent-analytics-meta",
                        ],
                    },
                    {
                        categoryCheckboxId: "checkbox-cookie-consent-marketing",
                        serviceCheckboxIds: [
                            "checkbox-cookie-consent-marketing-google",
                        ],
                    },
                ];
                let isSynchronizing = false;
                const syncCategoryToServices = (config) => {
                    const categoryValue = this.getCheckboxValue($root, config.categoryCheckboxId);
                    config.serviceCheckboxIds.forEach((checkboxId) => {
                        this.setCheckboxValue($root, checkboxId, categoryValue);
                    });
                };
                const syncServicesToCategory = (config) => {
                    const categoryValue = config.serviceCheckboxIds.some((checkboxId) => this.getCheckboxValue($root, checkboxId));
                    this.setCheckboxValue($root, config.categoryCheckboxId, categoryValue);
                };
                configs.forEach((config) => {
                    syncServicesToCategory(config);
                    $root.offon(`change.cookieConsentCategorySync-${config.categoryCheckboxId}`, `#${config.categoryCheckboxId}`, () => {
                        if (isSynchronizing) {
                            return;
                        }
                        isSynchronizing = true;
                        syncCategoryToServices(config);
                        isSynchronizing = false;
                    });
                    config.serviceCheckboxIds.forEach((checkboxId) => {
                        $root.offon(`change.cookieConsentServiceSync-${config.categoryCheckboxId}-${checkboxId}`, `#${checkboxId}`, () => {
                            if (isSynchronizing) {
                                return;
                            }
                            isSynchronizing = true;
                            syncServicesToCategory(config);
                            isSynchronizing = false;
                        });
                    });
                });
            }
            ShowAccountRecovery() {
                setTimeout(() => {
                    const showModalUrl = this.accountRecoveryModalUrl;
                    const postUrl = CS.Url.CSUrl("ModalRecommendedAccountRecoveryClosed");
                    var data = {};
                    const renderCondition = showModalUrl != null &&
                        postUrl != null &&
                        !this.accountRecoveryShowned;
                    if (renderCondition) {
                        CS.Controls.Popup.ShowAjaxModal(showModalUrl, null, ({ popup }) => {
                            var _a;
                            // Popup loaded
                            var isMandatory = $("#IsMandatory").val();
                            var postponementRemaining = $("#PostponementRemaining").val();
                            // Handle CONTINUE button
                            CS.Controls.Button.Events.Clicked({
                                selector: "#button-continue",
                                callback: (button, e) => {
                                    data = { askMeLater: false, isMandatory, postponementRemaining };
                                },
                            });
                            // Handle ASK ME LATER button
                            CS.Controls.Button.Events.Clicked({
                                selector: "#button-ask-me-later",
                                callback: (button, e) => {
                                    e.jqueryEventObject.preventDefault();
                                    data = { askMeLater: true, isMandatory, postponementRemaining };
                                    popup.Close(false);
                                },
                            });
                            const expiryElement = document.getElementById("grace-expiry-time");
                            const language = (_a = $("#AccountRecoveryLanguage")) === null || _a === void 0 ? void 0 : _a.val();
                            if (!expiryElement) {
                                return;
                            }
                            // Device time now
                            const now = new Date();
                            // Device time + 4 hours
                            const expiry = new Date(now.getTime() + (4 * 60 * 60 * 1000));
                            const formatted = expiry.toLocaleString(language, {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit"
                            });
                            expiryElement.textContent = " " + formatted;
                        }, () => {
                            // Popup closed
                            this.accountRecoveryShowned = true;
                            CS.Ajax.Post(postUrl, data, (response) => {
                                //if (response.Success) {}
                            });
                        }, false);
                    }
                }, 1000);
            }
        }
        Views.MasterPage = MasterPage;
        let MainWallName;
        (function (MainWallName) {
            MainWallName["DivisionWall"] = "divisionwall";
            MainWallName["EventWall"] = "eventwall";
            MainWallName["Messages"] = "messages";
            MainWallName["PinsWall"] = "pinswall";
            MainWallName["StatsWall"] = "statswall";
        })(MainWallName || (MainWallName = {}));
        let PageTransition;
        (function (PageTransition) {
            PageTransition[PageTransition["FromLeft"] = 0] = "FromLeft";
            PageTransition[PageTransition["FromRight"] = 1] = "FromRight";
            PageTransition[PageTransition["Opacity"] = 2] = "Opacity";
        })(PageTransition || (PageTransition = {}));
        new MasterPage();
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));
// function Test(): boolean {
//    let success = false;
//     let callCompleted = false;
//    let res = CS.Ajax.Post('/general/unlockpremium', { featureId: 1 }, (r) => {
//        console.log("nativepurchasesuccessful " + r);
//        success = r.Success;
//        //if (r.success) {
//        //}
//        //else {
//        //    alert('An error has occured');
//        //}
//    }, (e) => e.isSync = true);
//    console.log(success);
//    return success;
//}
function initMap() {
    CS.DOM.$body.trigger("initmap.eventswall");
}
//(function () {
//    const arl = new Object() as any;
//    arl._open = XMLHttpRequest.prototype.open;
//    arl._send = XMLHttpRequest.prototype.send;
//    arl.callback = function () {
//        const event = new CustomEvent('AjaxDetected', {
//            detail: {
//                url: this.url,
//                method: this.method,
//                data: this.data
//            }
//        });
//        document.body.dispatchEvent(event);
//    }
//    function notNullString(input) {
//        return input || '';
//    }
//    XMLHttpRequest.prototype.open = function (a, b) {
//        a = notNullString(a);
//        b = notNullString(b);
//        arl._open.apply(this, arguments);
//        arl.method = a;
//        arl.url = b;
//        if (a.toLowerCase() == 'get') {
//            arl.data = b.split('?');
//            arl.data = notNullString(arl.data[1]);
//        }
//    }
//    XMLHttpRequest.prototype.send = function (a) {
//        a = notNullString(a);
//        arl._send.apply(this, arguments);
//        if (arl.method.toLowerCase() == 'post') {
//            arl.data = a;
//        }
//        arl.callback();
//    }
//}());
//document.body.addEventListener('AjaxDetected', function (e: any) {
//    if (e.detail.url.indexOf('connectionData=%5B%7B%22name%22%3A%22signalrhub') > -1) {
//        try {
//            // Code throwing an exception
//            throw new Error();
//        } catch (e2) {
//            console.log('AJAX CALL ' + e.detail.method, (CS.SignalRHelper.Instance as any).connection.data, e.detail.url, e.detail.data, e2.stack);
//        }
//    }
//}, false);

//# sourceMappingURL=masterpage.js.map
